import { Flex, Skeleton } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { useHasNftHelperCollections } from '@ui/hooks/useCruisers';
import { useVenoSDK } from '@ui/providers/VenoSDKProvider';
import { getBoostTokens } from '@ui/queries/sdk';
import type { GardenType } from '@ui/utils/garden';
import { currentWallet } from '@veno-app/wallet';
import React from 'react';

import GardenHelpersMainContent from './GardenHelpersMainContent';
import GardenHelpersNoWater from './GardenHelpersNoWater';
import GardenViewHelpersPrelaunch from './GardenViewHelpersPrelaunch';
import GrowHelpersProvider from './GrowHelpersProvider';

const { useAccount } = currentWallet;

type GardenViewGrowHelpersProps = {
  type: GardenType;
};

function GardenViewGrowHelpers({ type }: GardenViewGrowHelpersProps) {
  const account = useAccount();
  const sdk = useVenoSDK();
  const hasNftHelperCollections = useHasNftHelperCollections();
  const query = getBoostTokens(sdk, account ?? '');
  const { data: tokens } = useQuery(query.queryKey, query.queryFn, {
    enabled: Boolean(account) && hasNftHelperCollections,
  });

  return (
    <>
      <Flex flexDir="column" maxW={{ desktop: '500px' }} marginX="auto">
        {!hasNftHelperCollections && <GardenViewHelpersPrelaunch />}
        {hasNftHelperCollections && tokens && tokens.gt(0) && (
          <GrowHelpersProvider gardenType={type}>
            <GardenHelpersMainContent />
          </GrowHelpersProvider>
        )}
        {hasNftHelperCollections && tokens && tokens.eq(0) && (
          <GardenHelpersNoWater />
        )}
        {hasNftHelperCollections && !tokens && (
          <Skeleton mx="auto" w="343px" h="70px" />
        )}
      </Flex>
    </>
  );
}

export default GardenViewGrowHelpers;
